import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-olm-requisition',
  templateUrl: './olm-requisition.component.html',
  styleUrls: ['./olm-requisition.component.css']
})
export class OlmRequisitionComponent implements OnInit {
    olmKeyno;

    public orderButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderhead', gotoParms: () => this.menu!.order_internal_no ?? '' }];

    public menu?: Menu;

    public itemsListStocks: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.olmKeyno = this.stateService.getStateParams()['olm_keyno'];
    }

    private async loadMenu() {
        if (!!this.olmKeyno) {
            this.menu = (await this.datatask.Post(786, { olm_keyno: this.olmKeyno }))[0];
        }
    }

    private async loadStocks() {
        if (!this.menu) return;

        return this.itemsListStocks = await this.datatask.Post(787, { stock_keyno_to: this.menu.stock_keyno_to }); //'7344700'
    }

    goBackToPrevious(item: any): void {
        if (!this.menu) return;

        item = item?.item ? item.item : item;

        this.datatask.Post(761, {
            stock_keyno_from: item.stock_keyno,
            stock_keyno_to: this.menu.stock_keyno_to,
            quantity: this.menu.quantity,
            olm_keyno: this.menu.olm_keyno
        }).then(() => this.stateService.back());
    }

    private async init() {
        await this.loadMenu();
        this.loadStocks();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    olm_keyno: string;
    stock_keyno_to: string;
    quantity: string;
    orderline_keyno: string;
    order_internal_no: string;
    prod_id: string;
    prod_name_long: string;
    order_order_no: string;
    requisition_no: string;
    stat_cust_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('olmRequisition', {
//        templateUrl: 'views/components/views/olmRequisition/olmRequisition.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'olmRequisitionService', 'requisitionCreateService', function ($stateParams, stateService, utilityService, olmRequisitionService, requisitionCreateService) {
//            const vm = this;
//            let olmKeyno = $stateParams.olm_keyno;

//            vm.model = {
//                orderButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.menu.order_internal_no }) }
//                ],
//                menu: {},
//                itemsListStocks: []
//            };

//            async function loadMenu() {
//                vm.model.menu = (await olmRequisitionService.getMenu({ olm_keyno: olmKeyno }))[0];
//            }

//            async function loadStocks() {
//                if (utilityService.validateParmsValue(vm.model.menu.stock_keyno_to) !== true) return;

//                return vm.model.itemsListStocks = await olmRequisitionService.listStocks({ stock_keyno_to: vm.model.menu.stock_keyno_to });
//            }

//            vm.goBackToPrevious = function (item) {
//                item = item?.item ? item.item : item;

//                requisitionCreateService.createRequisition({
//                    stock_keyno_from: item.stock_keyno,
//                    stock_keyno_to: vm.model.menu.stock_keyno_to,
//                    quantity: vm.model.menu.quantity,
//                    olm_keyno: vm.model.menu.olm_keyno
//                }).then(function () {
//                    stateService.back();
//                });
//            }

//            vm.$onInit = async function () {
//                await loadMenu();
//                loadStocks();
//            }
//        }]
//    });
//})();
